export type Suit = 'wands' | 'cups' | 'swords' | 'pentacles';

export const SUITS: readonly Suit[] = ['wands', 'cups', 'swords', 'pentacles'];

export interface CardDef {
    /** Stable id, saved in history: `major-07`, `cups-03`. Never renumber. */
    id: string;
    arcana: 'major' | 'minor';
    suit?: Suit;
    /** Majors 0-21; minors 1-14 (ace, 2-10, page, knight, queen, king). */
    rank: number;
}

const two = (n: number) => String(n).padStart(2, '0');

export const DECK: readonly CardDef[] = [
    ...Array.from({ length: 22 }, (_, rank) => ({
        id: `major-${two(rank)}`,
        arcana: 'major' as const,
        rank,
    })),
    ...SUITS.flatMap((suit) =>
        Array.from({ length: 14 }, (_, i) => ({
            id: `${suit}-${two(i + 1)}`,
            arcana: 'minor' as const,
            suit,
            rank: i + 1,
        }))
    ),
];

const BY_ID = new Map(DECK.map((c) => [c.id, c]));

export const cardById = (id: string): CardDef | undefined => BY_ID.get(id);
